import { Form } from "react-bootstrap";

import BaseInput from "./baseInput";

export default class TextInput extends BaseInput {
  public render(): JSX.Element {
    return (
      <Form.Control
        id={this.props.id}
        data-test="feedback-text-input"
        name={this.props.id}
        className={this.className}
        onChange={this.onChange}
        disabled={this.props.inputDisabled}
        value={this.props.answer ?? ""}
      ></Form.Control>
    );
  }
}
